import { createRef, useCallback, useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { ANIMATION_DURATION } from '@/ui/lib/constants';
import { cn } from '@/ui/lib/utils';
import { Button, Modal } from '@/ui/components/base';
import { MainMenu } from './MainMenu/MainMenu';
import { GameRules } from './GameRules/GameRules';
import { PlayHistory } from './PlayHistory/PlayHistory';
import { MenuIcon } from './MenuIcon/MenuIcon';
import './menu.css';

export type MenuItem = 'main' | 'gameRules' | 'playHistory';

const REFS: Record<MenuItem, React.RefObject<HTMLDivElement | null>> = {
    main: createRef<HTMLDivElement>(),
    gameRules: createRef<HTMLDivElement>(),
    playHistory: createRef<HTMLDivElement>(),
};

export const Menu = () => {
    const [menu, setMenu] = useState<MenuItem | null>(null);

    const toggleMenu = useCallback(() => setMenu((prev) => (prev ? null : 'main')), []);
    const backToMainMenu = useCallback(() => setMenu('main'), []);

    return (
        <>
            <Button className="menu__button" variant="ghost" size="small" onClick={toggleMenu}>
                <MenuIcon isOpen={!!menu} />
            </Button>

            <Modal
                className={cn('menu', menu === 'main' && 'menu--main')}
                isOpen={!!menu}
                onClose={() => setMenu(null)}
            >
                <SwitchTransition mode="out-in">
                    <CSSTransition
                        key={menu}
                        nodeRef={menu ? REFS[menu] : REFS['main']}
                        timeout={ANIMATION_DURATION}
                        classNames="fade"
                        unmountOnExit
                        mountOnEnter
                    >
                        <>
                            {menu === 'main' && <MainMenu ref={REFS.main} onNavigate={setMenu} />}
                            {menu === 'gameRules' && (
                                <GameRules ref={REFS.gameRules} onBack={backToMainMenu} />
                            )}
                            {menu === 'playHistory' && (
                                <PlayHistory ref={REFS.playHistory} onBack={backToMainMenu} />
                            )}
                        </>
                    </CSSTransition>
                </SwitchTransition>
            </Modal>
        </>
    );
};
